import { CHAIN_NAMESPACE, fromChainId } from '@shapeshiftoss/caip';
export const isUtxoChainId = (chainId) => fromChainId(chainId).chainNamespace === CHAIN_NAMESPACE.Utxo;
